import React from 'react'
import './admin-create-invoice.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import EditInvoice from '../EditInvoice/EditInvoice'

const AdminCreateInvoice = (props) => {
    const [school, setSchool] = React.useState('')
    const [month, setMonth] = React.useState([])
    const [year, setYear] = React.useState('')
    const [monthName, setMonthName] = React.useState('')
    const [monthNumber, setMonthNumber] = React.useState('')
    const [day, setDay] = React.useState('')
    const [family, setFamily] = React.useState(false)
    const [familyNameSuggestions, setFamilyNameSuggestions] = React.useState([])
    const [searchName, setSearchName] = React.useState('')
    const [invoice, setInvoice] = React.useState(false)
    const [myInvoiceId, setMyInvoiceId] = React.useState(Math.random().toString(16).slice(2))
    const [lessonsToBeBilled, setLessonsToBeBilled] = React.useState([])
    const [extrasToBeBilled, setExtrasToBeBilled] = React.useState([])

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        setInvoice({
            invoiceId: myInvoiceId,
            school: school,
            familyInfo: family,
            familyName: family.familyName,
            monthYear: `${monthName}/${year}`,
            year: year,
            monthNumber: monthNumber,
            status: 'Creating',
            lessonsToBeBilled: lessonsToBeBilled,
            extrasToBeBilled: extrasToBeBilled,
            waveCustomerId: family.waveCustomerId,
        })
    }, [school, month, day, year, family, lessonsToBeBilled, extrasToBeBilled])

    const tryToClose = (id) => {
        if(id === 'admin-create-invoice__wrapper') {
            props.setAdminCreateInvoice(false)
        }
    }

    const chooseTheMonth = (val) => {
        setMonth(val)
        setMonthNumber(val.split(',')[0])
        setMonthName(val.split(',')[1])
    }

    const searchDatabaseForFamilyName = (index, value) => {
        setSearchName(value)
        axios.get(`${baseUrl}/admin-search/${school}/${value}`, myHeader)
        .then(res => {
            setFamilyNameSuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const chooseTheFamily = (obj) => {
        setFamily(obj)
        setFamilyNameSuggestions([])
    }

    const addInvoiceAndClose = (invoice) => {
        props.setInvoices(prev => ([...prev, invoice]))
        props.setAdminCreateInvoice(false)
    }

    return (
        <div className='admin-create-invoice__wrapper' id='admin-create-invoice__wrapper' onClick={(e) => tryToClose(e.target.id)}>
            {school === '' || month === [] || day === '' || year === '' || !invoice.familyInfo ?
                <div className='admin-create-invoice__box'>
                    <h1>Create Invoice</h1>
                    <div className='admin-create-invoice__labels'>Which School:</div>
                    <select className='admin-create-invoice__choose-school' value={school} onChange={(e) => setSchool(e.target.value)}>
                        <option value="" default>Choose</option>
                        <option value="mma">Mountainside</option>
                        <option value="lsma">Lakeside</option>
                        <option value="tma">Treeside</option>
                        <option value="mor">Morningside</option>
                        <option value="psma">Parkside</option>
                        <option value="tem">Tempe</option>
                        <option value="den">Denton</option>
                        <option value="tul">Tulsa</option>
                    </select>
                    <div className='admin-create-invoice__labels'>Invoice for the month of:</div>
                    <select className='admin-create-invoice__choose-month' value={month} onChange={(e) => chooseTheMonth(e.target.value)}>
                        <option value={''} default>Choose</option>
                        <option value={["1", "January"]}>January</option>
                        <option value={["2", "February"]}>February</option>
                        <option value={["3", "March"]}>March</option>
                        <option value={["4", "April"]}>April</option>
                        <option value={["5", "May"]}>May</option>
                        <option value={["6", "June"]}>June</option>
                        <option value={["7", "July"]}>July</option>
                        <option value={["8", "August"]}>August</option>
                        <option value={["9", "September"]}>September</option>
                        <option value={["10", 'October']}>October</option>
                        <option value={["11", 'November']}>November</option>
                        <option value={["12", 'December']}>December</option>
                    </select>
                    <div className='admin-create-invoice__labels'>Day the Invoice will be sent out:</div>
                    <select className='admin-create-invoice__choose-day' value={day} onChange={(e) => setDay(e.target.value)}>
                        <option value="" default>Choose</option>
                        {[...Array(31)].map((num, i) => 
                            <option key={i} value={i + 1}>{i + 1}</option>
                        )}
                    </select>
                    <div className='admin-create-invoice__labels'>Choose year:</div>
                    <select className='admin-create-invoice__choose-year' value={year} onChange={(e) => setYear(e.target.value)}>
                        <option value="" default>Choose</option>
                        <option value={'2022'}>2022</option>
                        <option value={'2023'}>2023</option>
                        <option value={'2024'}>2024</option>
                        <option value={'2025'}>2025</option>
                        <option value={'2026'}>2026</option>
                        <option value={'2027'}>2027</option>
                        <option value={'2028'}>2028</option>
                        <option value={'2029'}>2029</option>
                        <option value={'2030'}>2030</option>
                    </select>
                    <div>
                        <div className='admin-create-invoice__labels'>Choose Family:</div>
                        { !family
                            ?
                            <div className="manually-enter-family-name">
                                <input className="admin-create-invoice__manually-enter-family-name-input" placeholder="Enter Family Name" value={searchName} onChange={(e) => searchDatabaseForFamilyName(props.index, e.target.value)} />
                            </div>
                            :
                            <div>{family.familyName}</div>
                        }
                        {familyNameSuggestions.length > 0 &&
                            <div className="manually-enter-family__suggestion-box">
                                {familyNameSuggestions.map((sugg) => (
                                    <h5 className="manually-enter-family__family-suggestions" key={sugg._id} onClick={() => chooseTheFamily(sugg)}>{sugg.primaryParentName} {sugg.familyName}</h5>
                                ))}
                            </div>
                        }
                    </div>
                </div>
            :
            <EditInvoice 
                editting={false}
                invoice={invoice}                     
                setOpenInvoice={setInvoice}
                setAdminCreateInvoice={props.setAdminCreateInvoice}
                updateInvoices={props.updateInvoices}
                addInvoiceAndClose={addInvoiceAndClose}
            />
            }
        </div>
    )
}
export default AdminCreateInvoice;